module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "First Name",
      "id": "first_name",
      "error": _vm.form.errors.get('first_name')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.first_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "first_name", $$v)
      },
      expression: "form.first_name"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Last Name",
      "id": "last_name",
      "error": _vm.form.errors.get('last_name')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.last_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "last_name", $$v)
      },
      expression: "form.last_name"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Username",
      "id": "username",
      "error": _vm.form.errors.get('username')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "select",
      "options": [{
          name: 'Admin',
          value: 'Admin'
        },
        {
          name: 'User',
          value: 'User'
        } ],
      "option_name": "name",
      "option_value": "value",
      "label": "Role",
      "id": "role",
      "error": _vm.form.errors.get('role')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.role),
      callback: function($$v) {
        _vm.$set(_vm.form, "role", $$v)
      },
      expression: "form.role"
    }
  }), _vm._v(" "), (!_vm.create) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.toggleSetPassword()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.setPassword ? 'Don\'t change password' : 'Change Password') + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.setPassword || _vm.create) ? _c('span', [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Password",
      "id": "password",
      "error": _vm.form.errors.get('password')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Confirm Password",
      "id": "password_confirmation",
      "error": _vm.form.errors.get('password_confirmation')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.form, "password_confirmation", $$v)
      },
      expression: "form.password_confirmation"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.create ? 'Create Admin' : 'Save Changes'))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3087ffbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/forms/AdminForm.vue
// module id = 520
// module chunks = 0